import {
  createAction,
  createAsyncAction,
  createStandardAction,
} from 'typesafe-actions';
import { SortDeviceOptions, SortProfileOptions } from '../../utilities';

export const loadDevicesPage = createAction('@DEVICES_PAGE/LOAD');

export const loadDevicesPageAsync = createAsyncAction(
  '@DEVICES_PAGE/LOAD_REQUEST',
  '@DEVICES_PAGE/LOAD_SUCCESS',
  '@DEVICES_PAGE/LOAD_FAILURE',
)<void, void, Error>();

export const setSortOptions = createStandardAction(
  '@DEVICES_PAGE/SET_SORT_OPTIONS',
)<SortDeviceOptions>();

export const setSearchQuery = createStandardAction(
  '@DEVICES_PAGE/SET_SEARCH_QUERY',
)<string>();

export const setSharingSortOptions = createStandardAction(
  '@DEVICES_PAGE/SET_SHARING_SORT_OPTIONS',
)<SortProfileOptions>();

export const setSharingSearchQuery = createStandardAction(
  '@DEVICES_PAGE/SET_SHARING_SEARCH_QUERY',
)<string>();

export const setOpenContentWarningOnLoad = createStandardAction(
  '@DEVICES_PAGE/SET_OPEN_CONTENT_WARNING_ON_LOAD',
)<string>();

export const clearOpenStatusPopoverOnLoad = createStandardAction(
  '@DEVICES_PAGE/CLEAR_OPEN_STATUS_POPOVER_ON_LOAD',
)();
